module.exports = mathSymbols = [
    {
      "character": "&#x221E;",
      "glyph": "∞",
      "asciimath": "oo",
      "name": "infinity",
    },
    {
      "character": "&#x3B1;",
      "glyph": "α",
      "asciimath": "alpha",
      "name": "alpha greek letter",
    },
    {
      "character": "&#x3B2;",
      "glyph": "β",
      "asciimath": "beta",
      "name": "beta greek letter",
    },
    {
      "character": "&#x3B2;",
      "glyph": "β",
      "asciimath": "beta",
      "name": "beta greek letter",
    },
    {
      "character": "&#x3B3;",
      "glyph": "γ",
      "asciimath": "gamma",
      "name": "gamma greek letter",
    },
    {
      "character": "&#x393;",
      "glyph": "Γ",
      "asciimath": "Gamma",
      "name": "capital gamma greek letter",
    },
    {
      "character": "&#x3B4;",
      "glyph": "δ",
      "asciimath": "delta",
      "name": "delta greek letter",
    },
    {
      "character": "&#x394;",
      "glyph": "Δ",
      "asciimath": "Delta",
      "name": "capital delta greek letter",
    },
    {
      "character": "&#x3B5;",
      "glyph": "ε",
      "asciimath": "epsilon",
      "name": "epsilon greek letter",
    },
    {
      "character": "&#x25B;",
      "glyph": "ɛ",
      "asciimath": "varepsilon",
      "name": "varepsilon greek letter",
    },
    {
      "character": "&#x3B6;",
      "glyph": "ζ",
      "asciimath": "zeta",
      "name": "zeta greek letter",
    },
    {
      "character": "&#x3B7;",
      "glyph": "η",
      "asciimath": "eta",
      "name": "eta greek letter",
    },
    {
      "character": "&#x3B8;",
      "glyph": "θ",
      "asciimath": "theta",
      "name": "theta greek letter",
    },
    {
      "character": "&#x398;",
      "glyph": "Θ",
      "asciimath": "Theta",
      "name": "capital theta greek letter",
    },
    {
      "character": "&#x3D1;",
      "glyph": "ϑ",
      "asciimath": "vartheta",
      "name": "vartheta greek letter",
    },
    {
      "character": "&#x3B9;",
      "glyph": "ι",
      "asciimath": "iota",
      "name": "iota greek letter",
    },
    {
      "character": "&#x3BA;",
      "glyph": "κ",
      "asciimath": "kappa",
      "name": "kappa greek letter",
    },
    {
      "character": "&#x3BB;",
      "glyph": "λ",
      "asciimath": "lambda",
      "name": "lambda greek letter",
    },
    {
      "character": "&#x39B;",
      "glyph": "Λ",
      "asciimath": "Lambda",
      "name": "capital lambda greek letter",
    },
    {
      "character": "&#x3BC;",
      "glyph": "μ",
      "asciimath": "mu",
      "name": "mu greek letter",
    },
    {
      "character": "&#x3BD;",
      "glyph": "ν",
      "asciimath": "nu",
      "name": "nu greek letter",
    },
    {
      "character": "&#x3BE;",
      "glyph": "ξ",
      "asciimath": "xi",
      "name": "xi greek letter",
    },
    {
      "character": "&#x39E;",
      "glyph": "Ξ",
      "asciimath": "Xi",
      "name": "capital xi greek letter",
    },
    {
      "character": "&#x3C0;",
      "glyph": "π",
      "asciimath": "pi",
      "name": "pi greek letter",
    },
    {
      "character": "&#x3A0;",
      "glyph": "Π",
      "asciimath": "Pi",
      "name": "capital pi greek letter",
    },
    {
      "character": "&#x3C1;",
      "glyph": "ρ",
      "asciimath": "rho",
      "name": "rho greek letter",
    },
    {
      "character": "&#x3C3;",
      "glyph": "σ",
      "asciimath": "sigma",
      "name": "sigma greek letter",
    },
    {
      "character": "&#x3A3;",
      "glyph": "Σ",
      "asciimath": "Sigma",
      "name": "capital sigma greek letter",
    },
    {
      "character": "&#x3C4;",
      "glyph": "τ",
      "asciimath": "tau",
      "name": "tau greek letter",
    },
    {
      "character": "&#x3C5;",
      "glyph": "υ",
      "asciimath": "upsilon",
      "name": "upsilon greek letter",
    },
    {
      "character": "&#x3D5;",
      "glyph": "ϕ",
      "asciimath": "phi",
      "name": "phi greek letter",
    },
    {
      "character": "&#x3A6;",
      "glyph": "Φ",
      "asciimath": "Phi",
      "name": "capital phi greek letter",
    },
    {
      "character": "&#x3C6;",
      "glyph": "φ",
      "asciimath": "varphi",
      "name": "varphi greek letter",
    },
    {
      "character": "&#x3C7;",
      "glyph": "χ",
      "asciimath": "chi",
      "name": "chi greek letter",
    },
    {
      "character": "&#x3C8;",
      "glyph": "ψ",
      "asciimath": "psi",
      "name": "psi greek letter",
    },
    {
      "character": "&#x3A8;",
      "glyph": "Ψ",
      "asciimath": "Psi",
      "name": "capital psi greek letter",
    },
    {
      "character": "&#x3C9;",
      "glyph": "ω",
      "asciimath": "omega",
      "name": "omega greek letter",
    },
    {
      "character": "&#x3A9;",
      "glyph": "Ω",
      "asciimath": "Omega",
      "name": "capital omega greek letter",
    },
    {
      "character": "&#x22C5;",
      "glyph": "⋅",
      "asciimath": "*",
      "name": "center dot",
    },
    {
      "character": "&#x2217;",
      "glyph": "∗",
      "asciimath": "**",
      "name": "asterisk",
    },
    {
      "character": "&#x22C6;",
      "glyph": "⋆",
      "asciimath": "***",
      "name": "star",
    },
    {
      "character": "/",
      "glyph": "/",
      "asciimath": "//",
      "name": "slash",
    },
    {
      "character": "\\",
      "glyph": "\\",
      "asciimath": "\\",
      "name": "backslash",
    },
    {
      "character": "&#xD7;",
      "glyph": "×",
      "asciimath": "xx",
      "name": "times",
    },
    {
      "character": "&#xF7;",
      "glyph": "÷",
      "asciimath": "-:",
      "name": "division",
    },
    {
      "character": "&#x22C9;",
      "glyph": "⋉",
      "asciimath": "|><",
      "name": "left normal factor semidirect product",
    },
    {
      "character": "&#x22CA;",
      "glyph": "⋊",
      "asciimath": "><|",
      "name": "right normal factor semidirect product",
    },
    {
      "character": "&#x22C8;",
      "glyph": "⋈",
      "asciimath": "|><|",
      "name": "bowtie",
    },
    {
      "character": "&#x2218;",
      "glyph": "∘",
      "asciimath": "@",
      "name": "circuference",
    },
    {
      "character": "&#x2295;",
      "glyph": "⊕",
      "asciimath": "o+",
      "name": "circled plus",
    },
    {
      "character": "&#x2297;",
      "glyph": "⊗",
      "asciimath": "ox",
      "name": "circled times",
    },
    {
      "character": "&#x2299;",
      "glyph": "⊙",
      "asciimath": "o.",
      "name": "circled dot",
    },
    {
      "character": "&#x2211;",
      "glyph": "∑",
      "asciimath": "sum",
      "name": "summatory",
    },
    {
      "character": "&#x220F;",
      "glyph": "∏",
      "asciimath": "prod",
      "name": "productory",
    },
    {
      "character": "&#x2227;",
      "glyph": "∧",
      "asciimath": "^^",
      "name": "wedge",
    },
    {
      "character": "&#x22C0;",
      "glyph": "⋀",
      "asciimath": "^^^",
      "name": "big wedge",
    },
    {
      "character": "&#x2228;",
      "glyph": "∨",
      "asciimath": "vv",
      "name": "vee",
    },
    {
      "character": "&#x22C1;",
      "glyph": "⋁",
      "asciimath": "vvv",
      "name": "big vee",
    },
    {
      "character": "&#x2229;",
      "glyph": "∩",
      "asciimath": "nn",
      "name": "cap",
    },
    {
      "character": "&#x22C2;",
      "glyph": "⋂",
      "asciimath": "nnn",
      "name": "big cap",
    },
    {
      "character": "&#x222A;",
      "glyph": "∪",
      "asciimath": "uu",
      "name": "cup",
    },
    {
      "character": "&#x22C3;",
      "glyph": "⋃",
      "asciimath": "uuu",
      "name": "big cup",
    },
    {
      "character": "&#x222B;",
      "glyph": "∫",
      "asciimath": "int",
      "name": "integral",
    },
    {
      "character": "&#x222E;",
      "glyph": "∮",
      "asciimath": "oint",
      "name": "line integral",
    },
    {
      "character": "&#x2202;",
      "glyph": "∂",
      "asciimath": "del",
      "name": "partial derivative",
    },
    {
      "character": "&#x2207;",
      "glyph": "∇",
      "asciimath": "grad",
      "name": "nabla as gradient",
    },
    {
      "character": "&#xB1;",
      "glyph": "±",
      "asciimath": "+-",
      "name": "plus or minus",
    },
    {
      "character": "&#x2205;",
      "glyph": "∅",
      "asciimath": "O/",
      "name": "emptyset",
    },
    {
      "character": "&#x2135;",
      "glyph": "ℵ",
      "asciimath": "aleph",
      "name": "aleph",
    },
    {
      "character": "&#x2234;",
      "glyph": "∴",
      "asciimath": ":.",
      "name": "therefore",
    },
    {
      "character": "&#x2235;",
      "glyph": "∵",
      "asciimath": ":'",
      "name": "because",
    },
    {
      "character": "&#x22EE;",
      "glyph": "⋮",
      "asciimath": "vdots",
      "name": "vertical dots",
    },
    {
      "character": "&#x22F1;",
      "glyph": "⋱",
      "asciimath": "ddots",
      "name": "diagonal dots",
    },
    {
      "character": "&#x2220;",
      "glyph": "∠",
      "asciimath": "/_",
      "name": "angle",
    },
    {
      "character": "&#x2322;",
      "glyph": "⌢",
      "asciimath": "frown",
      "name": "frown",
    },
    {
      "character": "&#x25B3;",
      "glyph": "△",
      "asciimath": "triangle",
      "name": "triangle",
    },
    {
      "character": "&#x22C4;",
      "glyph": "⋄",
      "asciimath": "diamond",
      "name": "diamond",
    },
    {
      "character": "&#x25A1;",
      "glyph": "□",
      "asciimath": "square",
      "name": "square",
    },
    {
      "character": "&#x2102;",
      "asciimath": "CC",
      "name": "complex set",
    },
    {
      "character": "&#x2115;",
      "asciimath": "NN",
      "name": "natural set",
    },
    {
      "character": "&#x211A;",
      "asciimath": "QQ",
      "name": "rational set",
    },
    {
      "character": "&#x211D;",
      "asciimath": "RR",
      "name": "real set",
    },
    {
      "character": "&#x2124;",
      "asciimath": "ZZ",
      "name": "integer set",
    },
    {
      "character": "&#xAC;",
      "glyph": "¬",
      "asciimath": "not",
      "name": "not",
    },
    {
      "character": "&#x21D2;",
      "glyph": "⇒",
      "asciimath": "=>",
      "name": "implies",
    },
    {
      "character": "&#x21D4;",
      "glyph": "⇔",
      "asciimath": "<=>",
      "name": "if and only if",
    },
    {
      "character": "&#x2200;",
      "glyph": "∀",
      "asciimath": "AA",
      "name": "for all",
    },
    {
      "character": "&#x2203;",
      "glyph": "∃",
      "asciimath": "EE",
      "name": "exists",
    },
    {
      "character": "&#xA0;",
      "glyph": " ",
      "asciimath": "\\",
      "name": "empty space",
    },
];
